import React from "react";
import TextInput from "uicomponents/TextInput";
import styles from "./CurrentEmployees.module.css";
import SelectInput from "uicomponents/SelectInput";
import DateInput from "uicomponents/DateInput";

const DependentFormComponent = (): JSX.Element => {
  return (
    <div className={styles.dependentFormContainer}>
      <div className={styles.formcell}>
        <TextInput
          name="firstName"
          type="string"
          label="First name"
          className={styles.flexTextInput}
        />
        <TextInput
          name="lastName"
          type="string"
          label="Last name"
          className={styles.flexTextInput}
        />
      </div>
      <div className={styles.formcell}>
        <SelectInput
          name="participantType"
          label="Participant type"
          className={styles.flexInputWidth}
          options={[
            {
              value: "Spouse",
              description: "Spouse",
            },
            {
              value: "Child",
              description: "Child",
            },
          ]}
          placeholder="Select"
        />
        <SelectInput
          label="Sex"
          name="gender"
          className={styles.flexInputWidth}
          options={[
            {
              value: "Male",
              description: "Male",
            },
            {
              value: "Female",
              description: "Female",
            },
          ]}
          placeholder="Select"
        />
        <DateInput
          name="dateOfBirth"
          label="Date of birth"
          className={styles.flexInputWidth}
        />
        <TextInput
          name="homeZip"
          label="Home zip code"
          className={styles.flexInputWidth}
        />
      </div>
    </div>
  );
};

export default DependentFormComponent;
